
<div #captureDiv  class="popup-content p-4 bg-white">
    <div class="p-left-id">
      <p>Coin Curiosity ID: <span>{{ data.coin?.custom_id }}</span></p>
    </div>
    <div class="p-right-id">
      <p>Coin Curiosity ID: <span>{{ data.coin?.custom_id }}</span></p>
    </div>
    <div class="center-log text-center my-2  my-md-3">
      <img src="assets/images/logo/Coin.svg" width="100px" alt="Logo">
    </div>
  
    <div class="row gx-0">
      <div class="col-6">
        <div class="img-box text-center">
          <img [src]="data.frontImageUrl"  class="img-fluid coin-img" alt="Front Image">
        </div>
      </div>
      <div class="col-6">
        <div class="img-box text-center">
          <img [src]="data.backImageUrl" class="img-fluid coin-img" alt="Back Image">
        </div>
      </div>
      <div class="col-12 ">
        <div >
           <div class="centered-text">
               CoinCuriosity.US
           </div>
        </div>
       </div>
    </div>
  </div>
  <div class="loading-overlay" *ngIf="isDownloading">
    <div class="spinner-container">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2">Downloading</p>
    </div>
  </div>
  
  